import { LIVE_LIST_NAMES } from '../apis';
import { LiveListOption } from '../apis/hooks/models/liveListOption';

/**
 * Maps a Live List payload into normalized Ship-To options.
 * Ensures option `value` is always a string for stable form comparisons.
 *
 * @param {{ items?: Array<{ label?: string, value?: string|number, metadata?: any, disabled?: boolean }> }|null|undefined} data
 * @returns {LiveListOption[]}
 */
const toShipToAddressOptions = (data) => {
	const rawOptions = Array.isArray(data?.items) ? data.items : [];
	return rawOptions.map(
		(option) =>
			new LiveListOption({
				...option,
				value: String(option?.value ?? ''),
				label: option?.label || '',
			})
	);
};

/**
 * Fetches the Ship-To live list and returns the original response plus
 * a normalized `options` array for UI consumption.
 *
 * @param {(request: { listName: string, filters?: any }) => Promise<any>} getLiveList
 * @returns {Promise<any & { options: LiveListOption[] }>}
 */
export const fetchShipToAddresses = async (getLiveList) => {
	const response = await getLiveList({
		listName: LIVE_LIST_NAMES.CUSTOMER_SHIP_TO_ADDRESSES,
	});

	if (response?.isAborted || response?.isError) {
		return {
			...response,
			options: [],
		};
	}

	return {
		...response,
		options: toShipToAddressOptions(response?.data),
	};
};
